/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Platform styles
import '@/styles/main.scss'
import 'nprogress/nprogress.css'

// Plugins
import vuetify from './vuetify'
import pinia from '@/store'
import createAppRouter from '../router'
import initI18n from './i18n'
import NProgress from 'nprogress'
import VueCookies from 'vue-cookies'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/style.css'
import { bugsnagVue } from './bugsnag'
import { VueSpinnersPlugin } from 'vue3-spinners'

// Types
import type { App } from 'vue'
import { IApp } from '@/types/app'
import { BugsnagPluginVueResult } from '@bugsnag/plugin-vue'

export function registerPlugins(app: App) {
  /**
   * Configure plugins
   */
  NProgress.configure({
    showSpinner: false
  })

  NProgress.start()

  // Extend Day.js with the RelativeTime and UTC plugins
  dayjs.extend(relativeTime)
  dayjs.extend(utc)

  /**
   * Register plugins
   */
  app
    .use(pinia)
    .use(vuetify)
    .use(VueCookies, { expires: '30d', secure: true })
    .use(createAppRouter(app as IApp))
    .use(bugsnagVue as BugsnagPluginVueResult)
    .use(PerfectScrollbarPlugin)
    .use(VueSpinnersPlugin)
  app.use(initI18n(app as IApp))
}
